import React from 'react'
import PropTypes from 'prop-types'

import Autosuggest from 'react-autosuggest'

import s from './SearchComponent.css'
import I18N from '../../utils/I18nMessageProvider'
import PoiRequests from '../../data/PoiRequests'
import { UNFOCUS_ELEMENT_ID } from './TripAdvisor'

const DEFAULT_RADIUS_KM = 10
const NUMBER_OF_ITEMS_TO_REQUEST = 15

class SearchComponent extends React.Component {

  constructor (props) {
    super(props)

    this.state = {
      value: '',
      suggestions: []
    }

    this.searchIconTimeout = null
  }

  clearSuggestions = () => {
    this.setState({
      suggestions: []
    })
  }

  getCountryName (countryCode) {
    return this.props.countryCodes[countryCode] || countryCode
  }

  getSuggestionValue (suggestion) {
    return suggestion.name
  }

  /**
   * @param value - the current value of the text input
   * @param reason - one of 'input-changed', 'input-focused', 'escape-pressed', 'suggestions-revealed', 'suggestion-selected'
   */
  onFetchRequired = ({value, reason}) => {
    // clear existing request timer
    if (this.searchIconTimeout) {
      window.clearTimeout(this.searchIconTimeout)
    }

    const searchStringTrimmed = value.trim()

    if (searchStringTrimmed.length < 3) {
      return
    }

    this.searchIconTimeout = window.setTimeout(() => {
      PoiRequests.searchQuery(searchStringTrimmed, this.props.mapPosition, NUMBER_OF_ITEMS_TO_REQUEST).then(
        (result) => {
          this.replaceDataSource(result)
        },
        (error) => {
          // better clear all data results than having a search string not matching the results
          this.setState({
            suggestions: []
          })
          console.log(error)
          this.props.onError(error.message)
        }
      )
    }, 300)
  }

  /**
   *
   * @param event
   * @param suggestion
   */
  onItemSelected = (event, {suggestion}) => {
    this.props.searchForCoords({lat: suggestion.lat, lng: suggestion.lng}, DEFAULT_RADIUS_KM)

    const activeElement = document.activeElement
    console.log('activeElement', activeElement)
    const unfocus = () => {
      const unfocusElement = document.getElementById(UNFOCUS_ELEMENT_ID)
      if (unfocusElement) {
        unfocusElement.focus()
        unfocusElement.blur()
      }

    }
    if (window.KesiTools) {
      window.KesiTools.hideKeyboard()
    }
    setTimeout(unfocus, 800)
  }

  onTextChange = (event, {newValue, method}) => {
    this.setState({
      value: newValue
    })
  }

  replaceDataSource (result) {
    if (!result || !result.success || !result.data) {
      console.log('Cannot add search results because either the object is null or the success value is not true')
      return
    }

    const dataSource = result.data.map(place => {
      return {
        lng: place.longitude,
        lat: place.latitude,
        country: place.country,
        name: place.name,
        countryName: this.getCountryName(place.country)
      }
    })

    this.setState({
      suggestions: dataSource
    })
  }

  renderSuggestion = (suggestion) => {
    return (
      <div className={s.searchItem}>
        <div className={s.header}>{suggestion.name}</div>
        <div className={s.extraInfo}>{suggestion.countryName}</div>
      </div>
    )
  }

  render () {
    const {value, suggestions} = this.state
    const inputProps = {
      placeholder: I18N.get('tripproxy.search.hint'),
      value: value,
      onChange: this.onTextChange
    }

    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onFetchRequired}
        onSuggestionsClearRequested={this.clearSuggestions}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        onSuggestionSelected={this.onItemSelected}
        inputProps={inputProps}
      />
    )
  }

}

SearchComponent.propTypes = {
  config: PropTypes.array.isRequired,
  functions: PropTypes.object.isRequired,
  filterSettings: PropTypes.object.isRequired,
  settingStates: PropTypes.object.isRequired,
  setCategoryVisible: PropTypes.func,
  setSelectedCountry: PropTypes.func,
  showSettingsWithId: PropTypes.string
}

export default SearchComponent



// WEBPACK FOOTER //
// ./src/components/TripAdvisor/SearchComponent.js